export default __webpack_public_path__ + "static/media/African.6963048d.png";